export default "b465d17c9fb55040.png"